import React from 'react'
import { LinkBtn, l } from '@manychat/manyui'

import { KnowledgeBaseLink } from 'common/core/components/SupportLinks'
import { OfferStepTypes } from 'common/settings/components/SettingsPanel/BillingInfoProducts/CancelSubscriptionModal/types'
import { analyticsService } from 'utils/services/analytics'

import bestPracticesImg from './assets/bestPractices.png'
import GuideImg from './assets/guide.png'

const GuideTours = () => {
  const handleClickVideo = () => {
    analyticsService.sendEvent(`SETTINGS.BILLING.CANCEL_MODAL.${OfferStepTypes.GUIDES}.FREE_VIDEO`)
  }
  const handleClickBestPractice = () => {
    analyticsService.sendEvent(
      `SETTINGS.BILLING.CANCEL_MODAL.${OfferStepTypes.GUIDES}.BEST_PRACTICE`,
    )
  }
  const handleClickBlog = () => {
    analyticsService.sendEvent(`SETTINGS.BILLING.CANCEL_MODAL.${OfferStepTypes.GUIDES}.BLOG`)
  }
  const handleClickKnowledge = () => {
    analyticsService.sendEvent(`SETTINGS.BILLING.CANCEL_MODAL.${OfferStepTypes.GUIDES}.KNOWLEDGE`)
  }
  const handleClickCommunity = () => {
    analyticsService.sendEvent(
      `SETTINGS.BILLING.CANCEL_MODAL.${OfferStepTypes.GUIDES}.FACEBOOK_COMMUNITY`,
    )
  }
  return (
    <>
      <div className="p-a-lg">
        <h1 className="m-b-lg">{l.translate('Let us try to help you')}</h1>
        <div className="d-flex align-center panel bg-primary p-a-md justify-between m-b">
          <div style={{ maxWidth: 310 }}>
            <span className="text-heading text-white">
              {l.translate('Manychat Free Video Course')}
            </span>
            <p className="text-white p-b-xxs m-b-md">
              {l.translate(
                'Everything you need to know to grow your business, from building your first chatbot to SMS automation—and beyond.',
              )}
            </p>
            <LinkBtn
              target="_blank"
              onClick={handleClickVideo}
              href="https://manychat.com/resources/video-course"
              size="small"
              variant="default"
            >
              {l.translate('Check it out')}
            </LinkBtn>
          </div>
          <img
            className="md-d-block d-none"
            src={GuideImg}
            style={{ maxWidth: 255, maxHeight: 179 }}
          />
        </div>
        <div
          className="d-flex align-center panel p-a-md justify-between m-b"
          style={{ backgroundColor: '#FFE475' }}
        >
          <div style={{ maxWidth: 310 }}>
            <span className="text-heading">{l.translate('Best Practices')}</span>
            <p className="p-b-xxs m-b-md">
              {l.translate(
                'From Chat Marketing to ads, you can find a plenty of different strategies for your business.',
              )}
            </p>
            <LinkBtn
              target="_blank"
              onClick={handleClickBestPractice}
              href="https://manychat.com/blog/category/guides-resources/best-practices/"
              size="small"
              variant="default"
            >
              {l.translate('Explore ideas in our Blog')}
            </LinkBtn>
          </div>
          <img style={{ maxWidth: 310 }} className="md-d-block d-none" src={bestPracticesImg} />
        </div>
        <span className="text-heading">{l.translate('Useful resources')}</span>
        <div className="d-flex justify-between flex-wrap">
          <div className="p-t-md" style={{ maxWidth: 200 }}>
            <a
              onClick={handleClickBlog}
              href="https://manychat.com/blog/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              {l.translate('Discover our blog')}
            </a>
            <p className="text-secondary">
              {l.translate('The latest marketing, sales, and service tips and news.')}
            </p>
          </div>
          <div className="p-t-md" style={{ maxWidth: 200 }}>
            <a
              onClick={handleClickKnowledge}
              href={KnowledgeBaseLink.HOME}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              {l.translate('Knowledge Base')}
            </a>
            <p className="text-secondary">
              {l.translate('Find answers to all your Manychat questions.')}
            </p>
          </div>
          <div className="p-t-md" style={{ maxWidth: 200 }}>
            <a
              onClick={handleClickCommunity}
              href="https://community.manychat.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              {l.translate('Our community')}
            </a>
            <p className="text-secondary">
              {l.translate('Manychat Community where you can get help.')}
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default GuideTours
